import React from 'react';
import { Box } from '@chakra-ui/react';
import TablaTalleresCulturales from './TablaTalleresCulturales';

const TalleresCulturales: React.FC = () => {
  return (
    <Box px={{ base: 2, md: 4 }} pt={79} pb={4}>
      <TablaTalleresCulturales />
    </Box>
  );
};

export default TalleresCulturales;
